import { AdminOrganizationInstructor } from 'types/admin/organizations';
import { create } from 'zustand';

type CommonState = {
  loading: boolean;
  name: string;
  numberOfLicensesToAdd: string | null;
  numberOfInvites: number;
  membershipDurationMonth: number;
  instructors: AdminOrganizationInstructor[];
  isDisabled: boolean;
};

type AddState = CommonState;

type EditState = CommonState & {
  id: string;
};

type State = AddState | EditState;

type Actions = {
  setLoading: (loading: boolean) => void;
  setName: (name: string) => void;
  setNumberOfLicensesToAdd: (numberOfLicensesToAdd: string | null) => void;
  setNumberOfInvites: (numberOfInvites: number) => void;
  setMembershipDurationMonth: (membershipDurationMonth: number) => void;
  setInstructors: (instructors: AdminOrganizationInstructor[]) => void;
  setIsDisabled: (isDisabled: boolean) => void;
  resetState: () => void;
};

export type { AddState, EditState, State };

const defaultCommonState: CommonState = {
  loading: false,
  name: '',
  numberOfLicensesToAdd: null,
  numberOfInvites: 0,
  membershipDurationMonth: 0,
  instructors: [],
  isDisabled: false,
};

export const useOrganizationEditorStore = create<State & Actions>((set) => ({
  ...defaultCommonState,
  setLoading: (loading) => set(() => ({ loading })),
  setName: (name) => set(() => ({ name })),
  setNumberOfLicensesToAdd: (numberOfLicensesToAdd) => set(() => ({ numberOfLicensesToAdd })),
  setNumberOfInvites: (numberOfInvites) => set(() => ({ numberOfInvites })),
  setMembershipDurationMonth: (membershipDurationMonth) => set(() => ({ membershipDurationMonth })),
  setInstructors: (instructors) => set(() => ({ instructors })),
  setIsDisabled: (isDisabled) => set(() => ({ isDisabled })),
  resetState: () => set(() => ({ ...defaultCommonState })),
}));
